import { ReactElement, ReactNode, useMemo } from 'react';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import type { AgentContext } from '../../../types';
import useCachedEnvironments from '../../../hooks/useCachedEnvironments';
import IconButton from '../../IconButton';
import Menu from '../../Menu';

type Props = {
  context?: AgentContext;
  onContextChange?: (context: AgentContext | undefined) => void;
  menuButton?: ReactElement;
  tooltip?: ReactNode;
};

const EnvPickerButton = ({
  context,
  onContextChange,
  menuButton,
  tooltip,
}: Props) => {
  const { data: environments } = useCachedEnvironments();
  const menuTooltip =
    tooltip === undefined ? 'Add environment to chat context' : tooltip;

  const options = useMemo(
    () =>
      (environments ?? []).map((env) => ({
        value: env.id,
        label: env.name,
      })),
    [environments],
  );

  const selectedOptions = context?.environmentIds ?? [];

  if (options.length === 0) return null;

  return (
    <Menu
      multiple
      showSearch
      menuTitle="Environments"
      tooltip={menuTooltip}
      options={options}
      selectedOptions={selectedOptions}
      onChange={(values) => {
        onContextChange?.({
          ...(context ?? {}),
          environmentIds: values,
        });
      }}
      menuButton={
        menuButton ?? (
          <IconButton size="small" sx={{ padding: '4px' }}>
            <AddRoundedIcon sx={{ fontSize: '18px' }} />
          </IconButton>
        )
      }
      anchorOrigin={{ vertical: -8, horizontal: 'left' }}
      transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    />
  );
};

export default EnvPickerButton;
